export const PERMISSIONS = {
	SpendSummaryRead: 'SpendSummary.Read',
	TransactionsWrite: 'Transactions.Write',
	TransactionsRead: 'Transactions.Read',
	OpportunitiesRead: 'Opportunities.Read',
	OpportunitiesWrite: 'Opportunities.Write',
	OpportunitiesVerify: 'Opportunities.Verify',
	RawDataWrite: 'RawData.Write',
	ExcelRead: 'Excel.Read',
	ExcelWrite: 'Excel.Write',
	TransactionsDeleteAll: 'Transactions.DeleteAll',
	SettingsWrite: 'Settings.Write',
	SettingsArchiveWrite: 'Settings.Archive.Write',
	SettingsClassificationWrite: 'Settings.Classification.Write',
	PlansRead: 'Plans.Read',
	PlansWrite: 'Plans.Write',
	ExecuteRead: 'Execute.Read',
	InsightsRead: 'Insights.Read',
	AnnotationsRead: 'Annotations.Read',
	AnnotationsWrite: 'Annotations.Write',
	BookmarksRead: 'Bookmarks.Read',
	BookmarksWrite: 'Bookmarks.Write',
	DataFactoryAccess: 'DataFactory.Access',
	CCORead: 'CCO.Read',
	CCOWrite: 'CCO.Write',
	UnpublishedDataApprove: 'UnpublishedData.Approve',
	UnpublishedDataRead: 'UnpublishedData.Read',
	UnpublishedDataWrite: 'UnpublishedData.Write',
	TaxonomyReleaseNotes: 'Taxonomy.ReleaseNotes',
	TaxonomyApplyNew: 'Taxonomy.ApplyNew',
	TaxonomyEdit: 'Taxonomy.Edit',
	SpendWheelRead: 'SpendWheel.Read',
	TrackingWrite: 'Tracking.Write',
	TaxonomyApply: 'Taxonomy.ApplyMapping',
	BenchMarkRead: 'BenchMark.Read',
	BenchMarkWrite: 'BenchMark.Write',
	AccessControlRead: 'AccessControl.Read',
	PortcoVisible: 'Portco.Visible',
	ApVendorDBRead: 'ApVendorDB.Read',
	ApVendorDBWrite: 'ApVendorDB.Write',
	SpendControllerRead: 'SpendController.Read',
	SpendControllerWrite: 'SpendController.Write',
	SpendControllerUpdate: 'SpendController.Update',
	SpendControllerUpload: 'SpendController.Upload',
	SpendControllerDelete: 'SpendController.Delete',
	SpendControllerUser: 'SpendController.User',
	AnalysisRead: 'Analysis.Read',
	InitiativesRead: 'Initiatives.Read',
	WavesRead: 'Waves.Read',
	BudgetRead: 'Budget.Read',
	CategoryRead: 'Category.Read',
	BaselineRead: 'Baseline.Read',
	PreWorkShopRead: 'PreWorkShop.Read',
	WorkShopRead: 'WorkShop.Read',
	SavingsSignOffRead: 'SavingsSignOff.Read',
	FinanceReportRead: 'FinanceReport.Read',
	MicroTailRead: 'MicroTailLaunch.Read',
};

export const SETTINGS_PERMISSIONS = [
	PERMISSIONS.SettingsWrite,
	PERMISSIONS.SettingsArchiveWrite,
	PERMISSIONS.SettingsClassificationWrite,
];

export const APPEND_PERMISSIONS = [
	PERMISSIONS.RawDataWrite,
	PERMISSIONS.TransactionsDeleteAll,
];

export const DOWNLOAD_PERMISSIONS = [
	PERMISSIONS.ExcelRead,
	PERMISSIONS.OpportunitiesRead,
];

export const UPLOAD_PERMISSIONS = [
	PERMISSIONS.ExcelWrite,
	PERMISSIONS.OpportunitiesVerify,
];

export const DATA_PERMISSIONS = [
	...APPEND_PERMISSIONS,
	...DOWNLOAD_PERMISSIONS,
	...UPLOAD_PERMISSIONS,
];
export const SPEND_CONTROLLER_PERMISSIONS = [
	PERMISSIONS.SpendControllerRead,
	PERMISSIONS.SpendControllerWrite,
	PERMISSIONS.SpendControllerUpdate,
	PERMISSIONS.SpendControllerUpload,
];
export const BENCHMARK_PERMISSIONS = [
	PERMISSIONS.BenchMarkRead,
	PERMISSIONS.BenchMarkWrite,
];

//super user & elevated user
export const APVENDORDB_PERMISSIONS = [
	PERMISSIONS.ApVendorDBRead,
	PERMISSIONS.ApVendorDBWrite,
];
//grouped permissions
export const PUSH_TO_DB_PERMISSIONS = [
	...BENCHMARK_PERMISSIONS,
	...APVENDORDB_PERMISSIONS,
];
export const APPEND_UPLOAD_PERMISSIONS = [
	...APPEND_PERMISSIONS,
	...UPLOAD_PERMISSIONS,
];
